<template>
	<v-btn
		v-bind="$props"
		text
		:color="color"
		:class="getQaSelectorClass()"
		:data-testid="testId"
		v-on="$listeners"
	>
		<slot />
	</v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
	name: 'text-button',
	extends: VBtn,
	props: {
		color: {
			type: String,
			default: 'syrenis-black'
		},
		testId: {
			type: String,
			default: 'cassie_textbutton'
		}
	},
	methods: {
		getQaSelectorClass () {
			const buttonText = this.$slots.default.find(({ text }) => text).text.trim().replace(/\s/g, '-').toLowerCase()
			return `qa-textbutton-${buttonText} text-none`
		}
	}
}
</script>

<style lang="scss" scoped>
	// Add hover lift effect to text buttons
	.v-btn--text {
		transition: all 0.3s ease;

		&:hover:not(:disabled) {
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}
	}
</style>
